/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  
  /* SPC */

    document.addEventListener("DOMContentLoaded", function () {
        const currentDayOfWeek = new Date().getDay(); // 0 = Sonntag, 6 = Samstag
        const isWeekend = (currentDayOfWeek === 0 || currentDayOfWeek === 6);
        const deliveryCounter = document.getElementById("spc-delivery-counter");
        const dynTime = document.getElementById("spc-dynTime");
    
        if (!isWeekend && deliveryCounter) {
            const countDownTime = new Date(); 
            countDownTime.setHours(13, 45, 0, 0); // Zielzeit 13:45 Uhr
    
            const interval = setInterval(() => {
                const now = new Date().getTime();
                const distance = countDownTime.getTime() - now;
    
                if (distance <= 0) {
                    clearInterval(interval);
                    deliveryCounter.remove();
                    return;
                }
    
                const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((distance / (1000 * 60)) % 60);
    
                if (dynTime) {
                    dynTime.textContent = `${hours} Std. und ${minutes} Min.`;
                    deliveryCounter.style.display = "block"; 
                }
            }, 1000);
        } else if (deliveryCounter) {
            deliveryCounter.remove();
        }
    });

    /* Zeigt Vertrauensgarantie-Modal auf der PDP an */
    document.addEventListener("DOMContentLoaded", function () {
      const modal = document.getElementById("spc-vertrauensgarantie-modal");
      const closeModal = document.querySelector(".spc-close");
      const atag = document.querySelector("a[title='Vertrauensgarantie']");
      
      if (atag) {
        atag.addEventListener("click", function (event) {
          event.preventDefault();
          modal.style.display = "flex";
        });
      }
    
      closeModal.addEventListener("click", function () {
        modal.style.display = "none";
      });
    
      window.addEventListener("click", function (event) {
        if (event.target === modal) {
          modal.style.display = "none";
        }
      });
    });

 function fixLbBundleCta() {
    document.querySelectorAll('.lb-bundle-cta.lb-classic').forEach(cta => {
      // Hauptcontainer
      cta.style.minWidth = '0';
      cta.style.width = '100%';
      cta.style.maxWidth = '100%';
      cta.style.boxSizing = 'border-box';

      // Innerer CTA-Wrapper
      const cont = cta.querySelector('.lb-bundle-cta-cont');
      if (cont) {
        cont.style.minWidth = '0';
        cont.style.width = '100%';
        cont.style.maxWidth = '100%';
        cont.style.boxSizing = 'border-box';
      }
    });
  }

  // Initial ausführen
  fixLbBundleCta();

  // App rendert dynamisch → beobachten
  const observer = new MutationObserver(fixLbBundleCta);
  observer.observe(document.body, { childList: true, subtree: true });

  


// Öffnet Tab bei Klick auf die Trusted-Shops Bewertungssterne 
document.addEventListener('DOMContentLoaded', function () {

  let handled = false;

  document.addEventListener('focusin', function (e) {

    if (
      e.target &&
      e.target.tagName === 'ETRUSTED-STAR-EXTENSION'
    ) {
      if (handled) return;
      handled = true;

      const trustedTab = document.querySelector(
        '[data-et-handle="tabs-trusted-shops-bewertungen"]'
      );

      if (trustedTab && !trustedTab.classList.contains('easytabs-active')) {
        trustedTab.click();
      }
    }

  });

  // 2️⃣ Reset, sobald der Nutzer irgendeinen Tab anklickt
  document.addEventListener('click', function (e) {

    const tab = e.target.closest('.easytabs-tab-item');
    if (tab) {
      handled = false;
    }

  });

});

(() => {
  function initBeforeAfterSlider(slider) {
    if (slider.dataset.sliderInitialized === 'true') return;
    slider.dataset.sliderInitialized = 'true';

    const updatePosition = (event) => {
      const rect = slider.getBoundingClientRect();
      const position = Math.max(
        0,
        Math.min(event.clientX - rect.left, rect.width)
      );

      slider.style.setProperty(
        '--position',
        `${(position / rect.width) * 100}%`
      );
    };

    slider.addEventListener('pointerdown', (event) => {
      slider.setPointerCapture(event.pointerId);
      slider.classList.add('is-dragging');
      updatePosition(event);
    });

    slider.addEventListener('pointermove', (event) => {
      if (slider.hasPointerCapture(event.pointerId)) {
        updatePosition(event);
      }
    });

    const stopDragging = (event) => {
      if (slider.hasPointerCapture(event.pointerId)) {
        slider.releasePointerCapture(event.pointerId);
      }

      slider.classList.remove('is-dragging');
    };

    slider.addEventListener('pointerup', stopDragging);
    slider.addEventListener('pointercancel', stopDragging);
  }

  function initializeSliders() {
    document
      .querySelectorAll('.spc-before-after')
      .forEach(initBeforeAfterSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSliders);
  } else {
    initializeSliders();
  }

  document.addEventListener('shopify:section:load', initializeSliders);
})();




(() => {
  const initialized = new WeakSet();

  function initGallery(gallery) {
    if (initialized.has(gallery)) return;
    initialized.add(gallery);

    function fixThumbnails() {
      gallery.querySelectorAll(
        '.product-single__thumbnail[aria-hidden="true"]'
      ).forEach(thumbnail => {
        thumbnail.removeAttribute('aria-hidden');
      });
    }

    fixThumbnails();

    const observer = new MutationObserver(fixThumbnails);

    observer.observe(gallery, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  function initAllGalleries() {
    document.querySelectorAll(
      '.product-single__thumbnails'
    ).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllGalleries
    );
  } else {
    initAllGalleries();
  }

  document.addEventListener(
    'shopify:section:load',
    initAllGalleries
  );
})();


  /* SPC - Bis hier */
 





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

